import React from 'react';
import { loan } from '../data/loan';
import type { BorrowerPair, PackageState } from '../types/disclosures';
interface DisclosureSummaryProps {
  pair: BorrowerPair;
  packageState: PackageState;
}
export function DisclosureSummary({
  pair,
  packageState
}: DisclosureSummaryProps) {
  const rows: {
    label: string;
    value: React.ReactNode;
  }[] = [{
    label: 'Borrower Pair',
    value: pair.label
  }, {
    label: 'Loan Amount',
    value: loan.amount
  }, {
    label: 'Loan Purpose',
    value: loan.purpose
  }, {
    label: 'Property',
    value: <span className="block" data-id="element-52" data-mp="2tzaa1s6c9ast">
          {loan.street}
          <span className="block text-slate-500" data-id="element-53" data-mp="2fyzhmkpdro5j">{loan.cityStateZip}</span>
        </span>
  }, {
    label: 'Rate',
    value: loan.rate
  }, {
    label: 'Disclosure Package',
    value: loan.packageType
  }, {
    label: 'Generated',
    value: packageState.generatedAt ?? <span className="text-slate-400" data-id="element-54" data-mp="i8g3qxw5jb6l">Not yet generated</span>
  }];
  return <aside className="rounded-xl border border-slate-200 bg-white shadow-card lg:sticky lg:top-6" data-id="element-55" data-mp="i63juf6u2qqw">
      <h2 className="border-b border-slate-100 px-5 py-3.5 text-[13px] font-semibold text-slate-900" data-id="element-56" data-mp="30oklhklbjaz9">
        Disclosure Summary
      </h2>
      <dl className="divide-y divide-slate-50" data-id="element-57" data-mp="3ah02aekvptik">
        {rows.map(row => <div key={row.label} className="px-5 py-3" data-id="element-58" data-mp="35hx9bsi6bdqy">
            <dt className="text-[11.5px] font-medium uppercase tracking-wide text-slate-400" data-id="element-59" data-mp="35ifbf5riom6s">
              {row.label}
            </dt>
            <dd className="mt-1 text-[13px] font-medium leading-5 text-slate-900" data-id="element-60" data-mp="2ct82dcufse7a">{row.value}</dd>
          </div>)}
      </dl>
    </aside>;
}